<template>
  <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
    <v-snackbar v-model="snackbar" :color="snackbar_color" :timeout="2000" >
      <span>{{message}}</span>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-card class="neu-glow">
        <v-card-title primary-title>
        <div class="text-h5">{{$t(page+'.Fatturazione')}} <span class="subtitle-1">({{$t(page+'.with red background')}})</span></div>
    </v-card-title>
    <v-container grid-list-xl fluid>
    <v-row>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.Next Invoice Number')"
              name="nextInvoiceNumber"
              v-model="form.nextInvoiceNumber"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.nextInvoiceNumber.$touch()"
              required
              background-color="#ff000010"
              filled
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'nextInvoiceNumber')" 
              reverse             
              @input.native="$parent.save"
              persistent-hint
              :hint="$t(page+'.Only for first Year: for following Years starts with 1')"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.Invoice Prefix')"
              name="invoicePrefix"
              v-model="form.invoicePrefix"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.invoicePrefix.$touch()"
              filled
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'invoicePrefix')"         
              @input.native="$parent.save"
              persistent-hint
              :hint="$t(page+'.For separate numbering sequence')"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.Invoice Suffix')"
              name="invoiceSuffix"
              v-model="form.invoiceSuffix"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.invoiceSuffix.$touch()"
              filled
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'invoiceSuffix')" 
              @input.native="$parent.save"
              persistent-hint
              :hint="$t(page+'.For separate numbering sequence')"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.Next Credit Note Number')"
              name="nextCreditNoteNumber"
              v-model="form.nextCreditNoteNumber"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.nextCreditNoteNumber.$touch()"
              required
              background-color="#ff000010"
              filled
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'nextCreditNoteNumber')"               
              reverse    
              @input.native="$parent.save"
              persistent-hint
              :hint="$t(page+'.Only for first Year: for following Years starts with 1')"              
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.Credit Note Prefix')"
              name="creditNotePrefix"
              v-model="form.creditNotePrefix"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.creditNotePrefix.$touch()"
              filled
              outlined
              dense
              clearable 
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'creditNotePrefix')"                  
              @input.native="$parent.save"
              persistent-hint
              :hint="$t(page+'.For separate numbering sequence')"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.Credit Note Suffix')"
              name="creditNoteSuffix"
              v-model="form.creditNoteSuffix"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.creditNoteSuffix.$touch()"
              filled
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'creditNoteSuffix')"                            
              @input.native="$parent.save"
          ></v-text-field>
        </v-col>
    </v-row>
    </v-container>
</v-card>
  </v-form>
</template>
<script>
import { mapGetters } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import { availableCountries  } from "@/config/countries";
import _ from 'lodash'
const defaultForm = {
  company: "",
  address: "",
  postalcode: "",
  buildingnumber:"",
  city: "",
  stateorprovince: "",
  country: "",
  companyid: "",
  vatnumber: "",
  sdi: "",
  pec:"",
  iban:"",
  swift:""
};

export default {
  props: ['form'],
  mixins: [validationMixin],
  validations: {
    form: {
      company: { required },
      address: { required },
      buildingnumber: { required},
      postalcode: { required, maxLength: maxLength(8) },
      city: { required },
      stateorprovince: { required },
      country: { required },
      companyid: { required },
      vatnumber: { required },
      sdi: { required },
      pec: { required },
      iban: { required }
    },
  },
  validationMessages: {
    form: {
      company: { required: "Choose your favorite animal" },
      address: { required: "Choose your favorite animal" },
      buildingnumber: { required: "enter building name" },
      city: { required: "City is required" },
      stateorprovince: { required: "State is required" },
      country: { required: "Country is required" },
      companyid: { required: "CompanyID is required" },
      vatnumber: { required: "TAX Number is required" },
      sdi: { required: "SDI is required" },
      iban: { required: "IBAN is required" },
      postalcode: {
        required: "PostalCode is required",
        maxLength: "Max 8 characters",
      },
    },
  },
  data() {
    return {
      page: "BossAccount",
      //form: this.$store.state.userdata.user,
      countries: availableCountries,
      snackbar: false,     
      message:'',
      snackbar_color:'success', 
    };
  },
  computed: {
      ...mapGetters(["user"]),
  },
  methods: {
    resetForm() {
      this.form = Object.assign({}, defaultForm);
      this.$refs.form.reset();
      this.$v.$reset();
    },
    submit() {
      this.resetForm();
      this.$v.$reset();
    },
    save: _.debounce(function (event) {
        this.$parent.updateDB(event.target.name,event.target.value)
    }, 1000),
  },
  beforeDestroy() {
    this.form = null;
    delete this.form;
  },
};
</script>